import { render, staticRenderFns } from "./TaxInputTable.vue?vue&type=template&id=495de0bd&scoped=true"
import script from "./TaxInputTable.vue?vue&type=script&lang=js"
export * from "./TaxInputTable.vue?vue&type=script&lang=js"
import style0 from "./TaxInputTable.vue?vue&type=style&index=0&id=495de0bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495de0bd",
  null
  
)

export default component.exports